module.exports = __webpack_public_path__ + "static/img/wxImg.2ffd25c3.png";